import { useQuery } from '@tanstack/react-query'

import { api } from '../../services/api'
import type { RoleDefaultConfig } from '../../services/api'

export type { RoleDefaultConfig }

export function useRoleDefaults() {
  return useQuery<RoleDefaultConfig[]>({
    queryKey: ['role-defaults'],
    queryFn: async () => {
      const res = await api.getRoleDefaults()
      return res.data
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  })
}
